import React from "react";
import Seo from "../components/Seo";
import Navbar from "../components/Navbar";
import StickyMobileCTA from "../components/StickyMobileCTA";
import Hero from "../components/sections/Hero";
import Marquee from "../components/sections/Marquee";
import Trust from "../components/sections/Trust";
import Problems from "../components/sections/Problems";
import Apartment from "../components/sections/Apartment";
import { Commercial, Residential } from "../components/sections/SplitBlocks";
import Services from "../components/sections/Services";
import ServiceArea from "../components/sections/ServiceArea";
import QuoteCTA from "../components/sections/QuoteCTA";
import About from "../components/sections/About";
import Careers from "../components/sections/Careers";
import Faq from "../components/sections/Faq";
import Footer from "../components/sections/Footer";

const Landing = () => (
  <div className="App bg-background">
    <Seo
      title="Jet Cleaning Service | DFW Apartment Turnover, Commercial & House Cleaning — Denton, TX"
      description="Jet Cleaning Service — DFW's apartment turnover cleaning specialists. Dependable make-ready, move-in/move-out, commercial, office & residential cleaning in Denton, TX and the Dallas–Fort Worth Metroplex. Request a free quote."
      path="/"
    />
    <div className="grain-overlay" aria-hidden="true" />
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Trust />
      <Problems />
      <Apartment />
      <Commercial />
      <Residential />
      <Services />
      <ServiceArea />
      <QuoteCTA />
      <About />
      <Careers />
      <Faq />
    </main>
    <Footer />
    <StickyMobileCTA />
    <div className="h-16 lg:hidden" aria-hidden="true" />
  </div>
);

export default Landing;
